// extracted by css-extract-rspack-plugin
export default {"link":"MzFpr","selected":"oH46A","icon":"fZIE8","round_icon":"XqbXB","roundIcon":"XqbXB"};